export interface ThemePreset {
  id: string;
  label: string;
  description: string;
  colors: {
    primary: string;
    secondary: string;
    accent: string;
    background: string;
    text: string;
    link: string;
    pill_bg: string;
    pill_text: string;
  };
}

export const THEME_PRESETS: ThemePreset[] = [
  {
    id: 'pink',
    label: 'Pink Magenta',
    description: 'Trenutna magenta tema — energična & ženstvena',
    colors: {
      primary: '#E60073',
      secondary: '#1F1F1F',
      accent: '#C40061',
      background: '#FFFFFF',
      text: '#1F1F1F',
      link: '#E60073',
      pill_bg: '#E60073',
      pill_text: '#FFFFFF',
    },
  },
  {
    id: 'yellow',
    label: 'Yellow Tabloid',
    description: 'Priporočena 2026 — drzna rumena tabloidna estetika',
    colors: {
      primary: '#111111',
      secondary: '#F7F7F7',
      accent: '#FFC700',
      background: '#FFFFFF',
      text: '#111111',
      link: '#111111',
      pill_bg: '#FFC700',
      pill_text: '#111111',
    },
  },
  {
    id: 'blue',
    label: 'Original Blue',
    description: 'Klasična modra iz originalnega logotipa',
    colors: {
      primary: '#000000',
      secondary: '#F0F4F8',
      accent: '#3FA0D8',
      background: '#FFFFFF',
      text: '#1A1A1A',
      link: '#3FA0D8',
      pill_bg: '#3FA0D8',
      pill_text: '#FFFFFF',
    },
  },
  {
    id: 'royal',
    label: 'Royal Glam',
    description: 'Premium vijolična varianta — elegantna & prestižna',
    colors: {
      primary: '#1A1A1A',
      secondary: '#F5F0FA',
      accent: '#6A0DAD',
      background: '#FFFFFF',
      text: '#1A1A1A',
      link: '#6A0DAD',
      pill_bg: '#6A0DAD',
      pill_text: '#FFFFFF',
    },
  },
  {
    id: 'lifestyle',
    label: 'Soft Lifestyle',
    description: 'Nežna berry tema — mehka & ženstvena',
    colors: {
      primary: '#2C2C2C',
      secondary: '#F8F5F7',
      accent: '#D63384',
      background: '#FAFAFA',
      text: '#2C2C2C',
      link: '#D63384',
      pill_bg: '#D63384',
      pill_text: '#FFFFFF',
    },
  },
];

export function getPresetById(id: string): ThemePreset | undefined {
  return THEME_PRESETS.find(p => p.id === id);
}
